// ============================================
// Settings Module - Events (ES6)
// 설정 이벤트 핸들러
// ============================================

import { closeSettingsModal } from './index.js';
import { openProfileManager } from '../profile/index.js';
import { handleLogout } from '../auth/index.js';
import { showToast } from '../utils.js';

// ============================================
// Settings Events Initialization
// ============================================

export function initSettingsEvents() {
  // === Settings Modal Back Button ===
  const settingsBackBtn = document.querySelector('#settingsModal .settings-back-btn');
  if (settingsBackBtn) {
    settingsBackBtn.addEventListener('click', closeSettingsModal);
  }

  // === Settings Rows (event delegation) ===
  const settingsContent = document.querySelector('#settingsModal .settings-full-content');
  if (settingsContent) {
    settingsContent.addEventListener('click', (e) => {
      const row = e.target.closest('.settings-row');
      if (!row) return;

      const action = row.dataset.action;
      if (action === 'profile-manager') {
        openProfileManager();
      } else if (action === 'logout') {
        handleLogout();
      } else if (action === 'coming-soon') {
        showToast('준비 중인 기능입니다');
      }
    });
  }

  console.log('[Settings Events] 이벤트 리스너 초기화 완료');
}
